<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <table
          v-if="ready"
          class="table table-condensed"
        >
          <thead>
            <tr>
              <th>{{ trans( 'core.name') }}</th>
              <th>{{ trans_choice('core.groups', 2) }}</th>
              <th>{{ trans_choice('core.lecturers', 2) }}</th>
              <th>{{ trans_choice('core.classrooms', 2) }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(event, index) in events">
              <td><span v-safe-html="onlyShowDiff(event.name, changed_events[index].name)" /></td>
              <td>
                <span
                  v-safe-html="onlyShowDiff(implode(event.groups), implode(changed_events[index].groups))"
                />
              </td>
              <td>
                <span
                  v-safe-html="onlyShowDiff(implode(event.lecturers), implode(changed_events[index].lecturers))"
                />
              </td>
              <td>
                <span
                  v-safe-html="onlyShowDiff(implode(event.classrooms), implode(changed_events[index].classrooms))"
                />
              </td>
            </tr>
          </tbody>
        </table>
        <div v-else>
          <i class="fa fa-spinner fa-spin fa-fw" /> Loading...
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  filters: {
    implode (value) {
      return value.join(', ')
    },
  },

  props: {
    formValues: {
      required: true,
      type: Object,
    },
  },

  data () {
    return {
      url: 'preview-actions',
      events: [],
      changed_events: [],
      events_ready: false,
      changed_events_ready: false,
    }
  },

  computed: {
    ready () {
      return this.events_ready && this.changed_events_ready
    },

    event_ids () {
      return this.$store.state.scheduleSync.event_ids
    },
    ...mapGetters(['actionObj']),
  },

  mounted () {
    this.getEvents()
    this.previewActions()
    this.$emit('canFinishStep')
  },

  methods: {
    onlyShowDiff (left, right) {
      if (left === right) {
        return left
      } else {
        return (
          left +
            ' <span class=\'fa fa-angle-double-right \' > </span> <mark>' +
            right +
            '</mark>'
        )
      }
    },

    getEvents () {
      this.events_ready = false
      axios.get('get-events', {
        params: {
          event_ids: this.event_ids,
        },
      }).then(response => {
        this.events = response.data.data.data
        this.events_ready = true
      })
    },
    previewActions () {
      this.changed_events_ready = false
      axios.post(this.url, {
        actions: this.actionObj,
        event_ids: this.event_ids,
        program_id: this.formValues.programId,
      }).then(response => {
        this.changed_events = response.data.data.data
        this.changed_events_ready = true
      })
    },

    implode (value) {
      return value.join(', ')
    },
  },
}
</script>
